<template>
  <div>
    <div class="common-header">
      <es-breadcrumb>
        <es-breadcrumb-item :to="{ path: '/MyOrder' }">{{ $t('我的订单') }}</es-breadcrumb-item>
        <es-breadcrumb-item>{{ isResale ? $t('操作转售') : $t('订单授权') }}</es-breadcrumb-item>
      </es-breadcrumb>
      <span class="common-header-tip">
        {{
          isResale
            ? $t('转售订单不可消费，若您在转售后希望使用此订单部分份额，请对您自己转售部分份额，请注意，所有转售份额不可取消；')
            : $t('*可授权企业用户须线下走授权申请')
        }}
      </span>
    </div>
    <divided />

    <div class="common-body">
      <div class="table">
        <div class="table-header">
          <span>{{ orderDetail.commodityName }}</span>
          <span class="table-header-number">{{ $t('订单编号：') }}{{ orderDetail.showId }}</span>
        </div>

        <div class="table-body">
          <es-row class="table-body-title">
            <es-col :span="5">{{ $t('产品规格数量') }}</es-col>
            <es-col :span="5">{{ $t('有效时间') }}</es-col>
            <es-col :span="5">{{ isResale ? $t('已转售量') : $t('已使用量') }}</es-col>
            <es-col :span="5">{{ isResale ? $t('剩余可转售量') : $t('当前余量') }}</es-col>
            <es-col v-if="orderType != 1" :span="4">{{ $t('付款状态') }}</es-col>
          </es-row>
          <es-row class="table-body-main">
            <es-col :span="5">{{
              orderDetail.isUnLimitNum ? $t('无限') : getShowPrice(orderDetail, 'totalNum', 'G') + getShowUnit(orderDetail)
            }}</es-col>
            <es-col :span="5">{{ orderDetail.startToEnd }}</es-col>
            <es-col :span="5">
              <span v-if="orderDetail.units === 'G'">{{ showDataUnit(orderDetail.used, 'floor', orderDetail) }}</span>
              <span v-else>{{ getShowPrice(orderDetail, 'used', 'KB', 1) + getShowUnit(orderDetail, 'KB', 1, 'used') }}</span>
            </es-col>
            <es-col :span="5">
              <span v-if="orderDetail.isUnLimitNum">{{ $t('无限') }}</span>
              <span v-else-if="orderDetail.units === 'G'">{{ showDataUnit(orderDetail.margin, 'ceil', orderDetail) }}</span>
              <span v-else>{{ getShowPrice(orderDetail, 'margin', 'G', 2) + getShowUnit(orderDetail, 'G') }}</span>
            </es-col>
            <es-col v-if="orderType != 1" :span="4">
              {{
                orderDetail.payStatus == 0
                  ? $t('待支付')
                  : orderDetail.payStatus == 1
                  ? $t('已支付')
                  : orderDetail.payStatus == 2
                  ? $t('付款中')
                  : orderDetail.payStatus == 3
                  ? $t('未支付')
                  : ''
              }}
            </es-col>
          </es-row>
        </div>
      </div>

      <div class="tip" v-show="$route.query.type === 'MyOrder'">
        {{ isResale ? $t('总共可转售：') : $t('当前总共可授权数量') }}
        <span style="font-weight: 600">{{ showValue }}</span>
      </div>
      <!-- 订单授权 -->

      <es-tabs v-model="activeName" v-if="!isResale">
        <es-tab-pane :label="$t(`添加授权方`)" name="add" v-if="$route.query.type === 'MyOrder'">
          <div class="anth-container">
            <div class="left-select">
              <div class="auth-title">{{ $t('可授权用户') }}</div>
              <p class="title-detail">{{ $t('选择：') }}</p>
              <div class="select-main">
                <es-autocomplete
                  class="inline-input"
                  v-model="searchAuthName"
                  :fetch-suggestions="queryAuthSearch"
                  :trigger-on-focus="false"
                  :placeholder="$t(`请输入授权用户名称`)"
                  @select="handleSearchAuth"
                  prefix-icon="el-icon-search"
                  clearable
                  @clear="getAuth('')"
                  withComputedSlotsStyle
                ></es-autocomplete>
                <div class="checkbox-section">
                  <es-checkbox-group v-model="checkedUser" @change="handleCheckedChange">
                    <es-checkbox class="checkbox-item" v-for="(user, index) in authUsers" :label="user.gid" :key="index">
                      {{ user.gidName }}
                    </es-checkbox>
                  </es-checkbox-group>
                  <p class="empty" v-if="authUsers.length === 0">{{ $t('无信息') }}</p>
                </div>
                <div class="check-all">
                  <es-checkbox-group v-model="checkAll" @change="handleCheckAllChange">
                    <es-checkbox :label="0" :key="0">{{ $t('全选') }}</es-checkbox>
                    <es-checkbox :label="1" :key="1">{{ $t('已授权') }}</es-checkbox>
                    <es-checkbox :label="2" :key="2">{{ $t('未授权') }}</es-checkbox>
                  </es-checkbox-group>
                </div>
              </div>
            </div>
            <div class="table">
              <div class="antu-title">{{ $t('已选') }}</div>
              <es-row class="table-body-title">
                <es-col :span="8">{{ $t('选择授权方名称') }}</es-col>
                <es-col :span="5">{{ $t('方式选择') }}</es-col>
                <es-col :span="5">{{ $t('最大可用量') }}</es-col>
                <es-col :span="2">{{ $t('操作') }}</es-col>
              </es-row>
              <div class="table-content">
                <es-row class="table-body-main" v-for="(item, index) in userAvailableList" :key="index">
                  <es-col :span="8">
                    <p class="auth-name">{{ item.name }}</p>
                  </es-col>
                  <es-col :span="5">
                    <es-switch
                      class="search-switch"
                      v-model="item.authType"
                      :active-text="$t(`配额`)"
                      :inactive-text="$t(`共享`)"
                      :active-value="2"
                      :inactive-value="0"
                      @change="
                        value => {
                          changeSwitch(value, item, index)
                        }
                      "
                    ></es-switch>
                  </es-col>
                  <es-col :span="5">
                    <div v-if="item.authType === 2" class="quotaOrder">
                      <es-input
                        class="search-input"
                        type="number"
                        v-model.number="item.amount"
                        @change="val => limitMaxNumber(val, item)"
                        :placeholder="$t('请输入数字')"
                      ></es-input>
                      {{ getShowUnit(orderDetail, 'G') }}
                    </div>
                    <div v-else class="shareOrder">
                      {{ orderDetail.isUnLimitNum ? $t('无限') : authLeaveNumber + getShowUnit(orderDetail, 'G') }}
                    </div>
                  </es-col>
                  <es-col :span="2">
                    <div class="operation">
                      <i class="es-icon-delete" @click="delUserAvailableItem(index, item)"></i>
                    </div>
                  </es-col>
                </es-row>
              </div>
            </div>
          </div>
        </es-tab-pane>
      </es-tabs>
      <!-- 操作转售 -->

      <div v-if="isResale">
        <div class="table-user-title">
          <div class="wd-400">
            {{ $t('选择被转售方名称') }}
            <span style="color: #999">{{ $t('（每次最多新增5个）') }}</span>
          </div>
          <div class="wd-260">
            <span v-show="!isProductOrder(orderDetail)">{{ $t('有效期') }}</span>
          </div>
          <div class="wd-360">
            <span v-show="!isProductOrder(orderDetail)">
              {{ $t('有效时间') }}
              <es-tooltip
                effect="dark"
                placement="bottom"
                width="200"
                :content="$t(`被转售方可使用此转售订单的时间范围，此时间范围应处于主订单有效期范围内；`)"
              >
                <i class="es-icon-warning" style="color: #999; font-size: 15px"></i>
              </es-tooltip>
            </span>
          </div>
          <div>{{ $t('最大可用量') }}</div>
        </div>

        <div v-for="(item, index) in resaleUserList" :key="index">
          <div class="reSale-user-body">
            <div class="wd-400">
              <es-autocomplete
                class="wd-360"
                :debounce="1000"
                :placeholder="$t(`请输入相关企业完整证件号或个人完整身份证`)"
                :trigger-on-focus="false"
                v-model.trim="item.name"
                :fetch-suggestions="querySearchAsync"
                @select="resaleHandleSelect"
                :disabled="item.disabled"
                @blur="onBlur(item.name)"
              ></es-autocomplete>
            </div>
            <div class="wd-260 flex">
              <div class="wd-100">
                <es-input-number
                  v-model="item.number"
                  controls-position="right"
                  :min="1"
                  @change="changeEndTime(item)"
                  :max="9999"
                  v-show="!isProductOrder(orderDetail)"
                ></es-input-number>
              </div>
              <div class="wd-100 ml-20">
                <es-select
                  v-model="item.units"
                  :placeholder="$t(`请选择`)"
                  @change="changeEndTime(item)"
                  v-show="!isProductOrder(orderDetail)"
                >
                  <es-option v-for="item in optionsList" :key="item.value" :label="item.label" :value="item.value"></es-option>
                </es-select>
              </div>
            </div>
            <div class="wd-360">
              <es-date-picker
                v-model="item.effectStartTime"
                v-show="!isProductOrder(orderDetail)"
                type="date"
                class="wd-150"
                :placeholder="$t(`选择日期`)"
                :picker-options="pickerOptions"
                value-format="timestamp"
                @change="changeEndTime(item)"
                :clearable="false"
              ></es-date-picker>
              <span style="margin: 0 5px" v-show="!isProductOrder(orderDetail)">-</span>
              <es-date-picker
                v-model="item.effectEndTime"
                v-show="!isProductOrder(orderDetail)"
                type="date"
                class="wd-150"
                :placeholder="$t(`选择日期`)"
                disabled
                value-format="timestamp"
              ></es-date-picker>
            </div>
            <div>
              <es-input v-model="item.selledAmount" class="wd-90" :placeholder="$t(`请输入数字`)" @blur="changeValue(item)"></es-input>
              <span style="margin: 0 0 0 5px">{{ getShowUnit(orderDetail) }}</span>
              <i
                class="el-icon-remove"
                @click="deleteUser(index, item)"
                style="color: #108de9; cursor: pointer"
                v-if="resaleUserList.length > 1"
              ></i>
            </div>
          </div>
          <div class="reSale-user-buttonGrup" v-if="showAddServerButton">
            <div class="hasPic" v-if="index == 0">
              <es-button type="primary" @click="openServer(index)">{{ $t('开通子服务') }}</es-button>
              <img src="./../../assets/common/tip.png" style="width: 160px" v-show="visible" @click="visible = false" />
            </div>
            <es-button type="primary" class="button" v-else @click="openServer(index)">{{ $t('开通子服务') }}</es-button>
          </div>
        </div>
        <es-button type="primary" class="add-button" @click="addItem" v-if="resaleUserList.length < 5">{{ $t('+ 添加') }}</es-button>
      </div>

      <div class="footer">
        <es-button type="primary" @click="onSubmit" v-show="$route.query.type == 'MyOrder'">{{ $t('下一步') }}</es-button>
      </div>
    </div>
    <!--开通子服务项  -->
    <es-dialog :title="$t(`开通子服务项`)" :visible.sync="dialogTableVisible" v-if="dialogTableVisible">
      <subServerTable
        :cakeOrderId="cakeOrderId"
        :orderId="orderDetail.id"
        @getServerData="getServerData"
        :checkedTag="checkedTag"
        :checkedTable="details"
        @cancle="cancle"
      ></subServerTable>
    </es-dialog>

    <es-dialog :title="$t(`重复授权提醒`)" :visible.sync="failResultListDialog">
      <div style="color: red; margin: 10px">
        <i class="es-icon-warning"></i>
        {{ $t('共享模式同一个订单一个用户只能共享一次，如下用户存在重复共享') }}
      </div>
      <es-table :data="failResultList" height="300">
        <es-table-column property="gidName" :label="$t(`重复被授权用户`)"></es-table-column>
      </es-table>
    </es-dialog>
  </div>
</template>
<script>
import { $t } from '@/locales'

/* eslint-disable */
import { mapState } from 'vuex'
import { formatUtc, getShowPrice, getShowUnit, showDataUnit, numberCal } from '@/util.js'
import divided from '../../components/divided'
import tsignData from '@tsign/tsigndata-sdk-js'

export default {
  components: {
    subServerTable: () => import('@/components/subServerTable.vue'),
    divided,
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
    }),
    placeholderText() {
      // 企业和个人输入框文案做区分
      return this.isOrg ? $t('请输入相关企业完整证件号,每次最多添加20个,可多次') : $t('请输入个人完整身份证号,每次最多添加20个,可多次')
    },
    showValue() {
      return this.orderDetail.isUnLimitNum
        ? $t('无限')
        : getShowPrice(this.orderDetail, 'margin', 'G', 1) + getShowUnit(this.orderDetail, 'G')
    },
    defaultNumber() {
      return this.orderDetail.saleType === 2 ? 80 : 1
    },
    // 3按量后付费 && 2充值式
    showAddServerButton() {
      return this.orderDetail.paymentType === 3 && this.orderDetail.saleType === 2
    },
    authLeaveNumber() {
      let count = this.authMaxNumber
      for (const val of this.userAvailableList) {
        if (val.authType === 2) {
          count -= val.amount
        }
      }

      return count
    },
    authrizedList() {
      return this.authUsers
        .filter(item => {
          return item.isShareAuth || item.isFixedAuth
        })
        .map(item => item.gid)
    },
    unAuthrizedList() {
      return this.authUsers
        .filter(item => {
          return !item.isShareAuth && !item.isFixedAuth
        })
        .map(item => item.gid)
    },
  },
  data() {
    return {
      ouid: '',
      orderType: 0,
      failResultList: [{ gidName: 1111 }],
      activeName: this.$route.query.type === 'MyOrder' ? 'add' : 'history',
      dialogTableVisible: false,
      failResultListDialog: false,
      visible: true,
      authMaxNumber: 0,
      optionsList: [
        { value: 'YEAR', label: $t('年') },
        { value: 'MONTH', label: $t('月') },
        { value: 'DAY', label: $t('日') },
      ],

      isResale: this.$route.query.isResale,
      results: [],
      checkOpenServerUserIndex: '',
      details: {},
      checkedTag: [],
      userAvailableList: [], // 授权用户列表
      checkedUser: [], // 已选授权用户数组
      authUsers: [], // 可授权用户数组
      checkAll: [],
      resaleUserList: [], // 转售用户列表
      searchAuthName: '',
      orderDetail: {},
      cb: null,
      queryString: '',
      getShowUnit,
      getShowPrice,
      showDataUnit,
      tipList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        },
      },
    }
  },
  methods: {
    cancle() {
      this.dialogTableVisible = false
    },
    getServerData({ checkedTag, details }) {
      this.dialogTableVisible = false
      this.resaleUserList[this.checkOpenServerUserIndex].details = details
      this.resaleUserList[this.checkOpenServerUserIndex].checkedTag = checkedTag
    },
    openServer(index) {
      this.checkOpenServerUserIndex = index
      this.details = this.resaleUserList[this.checkOpenServerUserIndex].details
      this.checkedTag = this.resaleUserList[this.checkOpenServerUserIndex].checkedTag
      this.visible = false
      this.dialogTableVisible = true
    },

    isProductOrder(item) {
      // 产品类订单
      const productOrderList = [2, 11, -2]

      return productOrderList.some(resaleItem => item.productType === resaleItem)
    },
    changeValue(item) {
      if (!item.selledAmount) {
        return
      }
      const rep = /^[1-9][0-9]{0,9}$/
      if (!rep.test(item.selledAmount)) {
        item.selledAmount = ''
      }
    },
    deleteUser(index, userItem) {
      this.resaleUserList.splice(index, 1)
      this.tipList = this.tipList.filter(item => item.guid !== userItem.guid)
    },
    // 获取当天0点时间戳
    getToday000000Date() {
      return +new Date(new Date(new Date().toLocaleDateString()).getTime())
    },
    changeEndTime(item) {
      this.$nextTick(() => {
        item.number = parseInt(item.number, 10) || 1
        const dayFormatDic = {
          YEAR: 366,
          MONTH: 31,
          DAY: 1,
        }
        const day = dayFormatDic[item.units]
        const date = item.number * day * 24 * 60 * 60 * 1000
        item.effectEndTime = item.effectStartTime + date + 24 * 60 * 60 * 1000 - 1000
      })
    },
    getOrderResellEffectiveDate(selectItem) {
      this.$ajax(this.$url.orderResellEffectiveDate(selectItem.guid), {
        sellProductId: this.orderDetail.productId,
      }).then(res => {
        if (res.data.length > 0) {
          this.tipList.push({
            ...res.data[0],
            ...selectItem,
          })
        }
      })
    },
    addItem() {
      // 计算主订单剩余有效期
      const restDay = this.orderDetail.isUnLimitTime
        ? 366
        : Math.floor(numberCal.div(this.orderDetail.endTime - this.getToday000000Date(), 86400000))
      const obj = {
        number: this.orderDetail.isUnLimitTime ? 1 : restDay,
        units: this.orderDetail.isUnLimitTime ? 'YEAR' : 'DAY',
        effectStartTime: this.getToday000000Date(),
        effectEndTime: this.getToday000000Date() + restDay * 60 * 60 * 24 * 1000,
        details: [],
        checkedTag: {},
      }
      this.resaleUserList.push(obj)
    },
    // eslint-disable-next-line consistent-return
    async resaleHandleSelect(selectItem) {
      const data = {
        // sellPersonalOid: selectItem.ouid,
        sellGid: this.orderDetail.gid,
        sellOid: this.orderDetail.userInfo.id.ouid,
        sellOrderId: this.orderDetail.id,
        selledGid: selectItem.guid,
      }
      try {
        await this.$ajax(this.$url.preCheck(), data)
        this.resaleUserList.forEach(item => {
          if (item.name === selectItem.value) {
            item.guid = selectItem.guid
            this.$set(item, 'disabled', true)
            item.oldName = selectItem.oldName
          }
        })
        this.getOrderResellEffectiveDate(selectItem)
      } catch (error) {
        this.resaleUserList.forEach(item => {
          if (item.name === selectItem.value) {
            item.name = ''
            this.$set(item, 'disabled', false)
          }
        })
      }
    },
    // eslint-disable-next-line consistent-return
    querySearchAsync(queryString, cb) {
      queryString = queryString.replace(/\s*/g, '')
      const rep = /^[0-9a-zA-Z_-]{1,30}$/
      if (!rep.test(queryString)) {
        this.$message.error($t('请输入30位以内字母或数字'))

        return
      }
      if (!queryString) {
        return
      }
      const data = {
        codeValue: queryString,
        pageSize: 100,
      }
      this.$ajax(this.$url.getByCode(), data).then(res => {
        const results = []
        if (res.data) {
          const resData = res.data
          const oldName = resData.properties.INFO_NAME
          const value = `*${resData.properties.INFO_NAME.substring(1, resData.properties.INFO_NAME.length)}`
          results.push({
            oldName,
            value,
            guid: resData.guid,
            accountType: resData.accountType,
          })
        }
        this.results = results
        cb(results)
      })
      this.cb = cb
    },
    onBlur(value) {
      const rep = /^[0-9a-zA-Z]{1,30}$/
      if (rep.test(value) && this.results.length === 0) {
        this.$message.error($t('您输入的相关企业完整证件号或个人完整身份证不存在'))
      }
    },
    getOrderDetail() {
      const { authOrderId } = this.$route.query
      const oid = this.userInfo.orgId ? this.userInfo.orgId : this.ouid
      this.$ajax(this.$url.getOrderDetail({ id: authOrderId, type: this.orderType }, oid)).then(res => {
        if (res.code === 20502002) {
          this.$message.error(res.message)
          this.$router.push('/Myorder')
        } else {
          this.orderDetail = res.data
          if (!this.isResale) {
            this.getAuth('')
          }
          this.authMaxNumber = Number(getShowPrice(this.orderDetail, 'margin', 'G', 1))
          this.authOrdreInit()
          if (this.orderDetail.productType === 10) {
            this.orderDetail.used = this.orderDetail.sellAmount
          }
          this.orderDetail.startToEnd = !this.isProductOrder(this.orderDetail)
            ? `${formatUtc(this.orderDetail.startTime, 'day')} ~ ${
                this.orderDetail.isUnLimitTime ? $t('无限') : formatUtc(this.orderDetail.endTime, 'day')
              }`
            : '--'
          this.addItem()
        }
      })
    },
    // 改变授权方式
    changeSwitch(value, item, index) {
      if (!item.allowAllType) {
        const v = value === 0 ? 2 : 0
        this.$set(this.userAvailableList[index], 'authType', v)
        this.$message.error($t('同个客户同个商品仅支持一种授权模式，若需此操作，请先取消原有授权方式！'))
      } else {
        if (value === 2) {
          this.$set(this.userAvailableList[index], 'amount', 0)
        } else {
          this.$set(this.userAvailableList[index], 'amount', this.authLeaveNumber)
        }
      }
    },
    // 授权列表是否全选
    isCheckAll() {
      // 是否全选
      const res = this.authUsers.every(item => {
        return this.checkedUser.includes(item.gid)
      })
      // 是否全部已授权
      const res1 =
        this.authrizedList.every(item => {
          return this.checkedUser.includes(item)
        }) &&
        this.authrizedList.length === this.checkedUser.length &&
        this.authrizedList.length
      // 是否全部未授权
      const res2 =
        this.unAuthrizedList.every(item => {
          return this.checkedUser.includes(item)
        }) &&
        this.unAuthrizedList.length === this.checkedUser.length &&
        this.unAuthrizedList.length
      if (res) return [0]
      if (res1) return [1]
      if (res2) return [2]
      return []
    },
    // 可授权用户列表
    async getAuth(gidName) {
      const res = await this.$ajax(this.$url.getAuthList(), {
        gidName,
        authGid: this.orderDetail.gid,
        showId: this.orderDetail.showId,
        orderType: this.orderType,
      })
      this.authUsers = res.data

      return res.data
    },
    // 判断授权模式
    checkAuthType(isShareAuth, isFixedAuth) {
      // 0 错误数据，不提交  1 仅共享授权  2仅配额授权 3两种都可以
      if (isShareAuth && isFixedAuth) {
        return 0
      } else if (!isShareAuth && isFixedAuth) {
        return 2
      } else if (isShareAuth && !isFixedAuth) {
        return 1
      }

      return 3
    },
    addUserAvailableList(val) {
      this.userAvailableList.push({
        gid: val.gid,
        name: val.gidName,
        authType: this.checkAuthType(val.isShareAuth, val.isFixedAuth) === 2 ? 2 : 0, // 授权订单操作方式  2配额  0 共享
        amount: this.checkAuthType(val.isShareAuth, val.isFixedAuth) === 2 ? 0 : this.authLeaveNumber, // 配额授权默认为0
        margin: this.authMaxNumber,
        allowAllType: this.checkAuthType(val.isShareAuth, val.isFixedAuth) === 3, // 是否允许两种配额方式
      })
    },
    sortAuthUsers() {
      this.authUsers.sort((a, b) => {
        return Number(this.checkedUser.includes(b.gid)) - Number(this.checkedUser.includes(a.gid))
      })
    },
    handleCheckAllChange(item) {
      tsignData.track('PC_bill_Full', { buttonName: 'authorization' })
      if (this.checkAll.length) this.checkAll = this.checkAll.slice(-1)
      if (item.length) {
        const [flg] = this.checkAll
        this.checkedUser = []
        for (const val of this.authUsers) {
          // 错误数据不处理
          if (!this.checkAuthType(val.isShareAuth, val.isFixedAuth)) {
            continue
          }
          // 当前遍历项在右侧数据列表中的索引
          const gidIndex = this.userAvailableList.findIndex(item => item.gid == val.gid)
          if (flg === 1) {
            if (val.orderAuthFlag) {
              this.checkedUser.push(val.gid)
              // 右侧列表中不存在的已授权的数据加入
              if (gidIndex < 0) {
                this.addUserAvailableList(val)
              }
            } else {
              // 右侧列表中已有的不属于已授权的数据去除
              if (gidIndex >= 0) {
                this.userAvailableList.splice(gidIndex, 1)
              }
            }
          } else if (flg === 2) {
            if (!val.orderAuthFlag) {
              this.checkedUser.push(val.gid)
              if (gidIndex < 0) {
                this.addUserAvailableList(val)
              }
            } else {
              if (gidIndex >= 0) {
                this.userAvailableList.splice(gidIndex, 1)
              }
            }
          } else {
            this.checkedUser.push(val.gid)
            if (this.userAvailableList.findIndex(item => item.gid == val.gid) < 0) {
              this.addUserAvailableList(val)
            }
          }
        }
        if (flg === 1 || flg === 2) this.sortAuthUsers()
      } else {
        for (const val of this.checkedUser) {
          // 删除已选
          const i = this.userAvailableList.findIndex(item => item.gid == val)
          if (i > -1) {
            this.userAvailableList.splice(i, 1)
          }
        }
        this.checkedUser = []
      }
    },
    // 输入框搜索授权用户
    handleSearchAuth(item) {
      this.getAuth(item.value)
    },
    async queryAuthSearch(queryString, cb) {
      if (!queryString) {
        return
      }
      let results = await this.getAuth(queryString)
      results = results.map(item => {
        return { value: item.gidName }
      })
      cb(results)
    },
    handleCheckedChange(item) {
      // 已配额份数
      if (this.authLeaveNumber <= 0) {
        this.$message.error($t('添加的授权数量不能大于可授权数量'))

        return
      }
      this.checkAll = this.isCheckAll()
      // 右边同步左边 选中
      for (const val of item) {
        if (this.userAvailableList.findIndex(item => item.gid == val) < 0) {
          const shareAuth = this.authUsers.find(item => item.gid === val).isShareAuth
          const fixedAuth = this.authUsers.find(item => item.gid === val).isFixedAuth
          this.userAvailableList.push({
            gid: val,
            name: this.authUsers.find(item => item.gid === val).gidName,
            authType: this.checkAuthType(shareAuth, fixedAuth) === 2 ? 2 : 0, // 授权订单操作方式  2配额  0 共享
            amount: this.checkAuthType(shareAuth, fixedAuth) === 2 ? 0 : this.authLeaveNumber, // 配额授权默认为0
            margin: this.authMaxNumber,
            allowAllType: this.checkAuthType(shareAuth, fixedAuth) === 3, // 是否允许两种配额方式
          })
        }
      }
      // 右边同步左边  不选中
      this.userAvailableList.forEach((ele, index) => {
        if (!item.includes(ele.gid)) {
          this.userAvailableList.splice(index, 1)
        }
      })
    },
    authOrdreInit() {
      if (this.$route.query.type === 'MyOrder') {
        if (this.$route.query.source === 'sureSend') {
          // 点击上一步，返回，自动更新可分配量，已授权数据保留
          const detailInfo = JSON.parse(sessionStorage.getItem('detailInfo'))
          this.userAvailableList = detailInfo.authList
          this.checkedUser = this.userAvailableList.map(item => item.gid)
        }
      }
    },
    returnMsgboxMessage(arr) {
      const h = this.$createElement

      return h('div', null, [
        h('div', { style: { display: 'flex', marginBottom: '10px' } }, [
          h('div', null, [
            arr.map((item, index) =>
              h(
                'div',
                {
                  style: { marginBottom: '5px' },
                },
                [
                  h('div', null, `${index + 1}. ${item.oldName}`),
                  h(
                    'div',
                    { style: { marginLeft: '14px' } },
                    $t('生效日期: {slot1} ~ {slot2}', {
                      slot1: formatUtc(item.effectStartTime, 'day'),
                      slot2: formatUtc(item.effectEndTime, 'day'),
                    })
                  ),
                ]
              )
            ),
          ]),
        ]),

        h('div', null, $t('以上被转售方的有效期超出了您主订单的有效期')),
        h('div', null, $t('{slot1}，请您调整他们的有效期；', { slot1: this.orderDetail.startToEnd })),
      ])
    },

    returnTipMessage(arr) {
      const h = this.$createElement

      return h('div', null, [
        h('div', { style: { display: 'flex', marginBottom: '10px' } }, [
          h('div', null, [
            arr.map((item, index) =>
              h(
                'div',
                {
                  style: { marginBottom: '5px' },
                },
                [
                  h('div', null, `${index + 1}. ${item.oldName}`),
                  h(
                    'div',
                    { style: { marginLeft: '14px' } },
                    $t('当前已有生效中的相同产品订单,有效期截止{slot1},请您确认生效日期和有效期！', {
                      slot1: item.endTime >= 4449525071000 ? $t('无限') : formatUtc(item.endTime, 'day'),
                    })
                  ),
                ]
              )
            ),
          ]),
        ]),

        this.isResale &&
        this.orderDetail.isTying &&
        this.orderDetail.saleType !== 2 &&
        this.resaleUserList.some(item => item.selledAmount < this.orderDetail.saleInfoTotalNum)
          ? h(
              'div',
              { style: { fontSize: '14px', margin: '0px' } },
              $t(`注意：您的转售存在转售数量小于搭售要求的规格{slot}的操作，不会搭售对应套餐`, {
                slot: getShowPrice(this.orderDetail, 'saleInfoTotalNum', 'G', 2) + getShowUnit(this.orderDetail),
              })
            )
          : '',
      ])
    },

    // eslint-disable-next-line complexity
    onSubmit() {
      if (!this.isResale && this.userAvailableList.length === 0) {
        this.$message.error($t('请添加被授权方'))

        return
      }
      if (
        !this.isResale &&
        !this.userAvailableList.every(item => {
          if (item.authType === 2) {
            return item.amount > 0
          }

          return this.authLeaveNumber > 0
        })
      ) {
        this.$message.error($t('授权数量不能为0'))

        return
      }

      if (this.isResale && !this.resaleUserList.every(item => item.guid)) {
        this.$message.error($t('请输入被转售方'))

        return
      }

      if (this.showAddServerButton && this.isResale) {
        const noSubServerList = []
        this.resaleUserList.forEach(item => {
          if (item.details.length === 0) {
            noSubServerList.push(item.oldName)
          }
        })
        if (noSubServerList.length > 0) {
          this.$message.error(
            $t('{slot1}还未选子服务项/添加价格，它将无法使用{slot2}订单，请先勾选再确认转售', {
              slot1: noSubServerList.join(','),
              slot2: this.orderDetail.commodityName,
            })
          )

          return
        }
      }
      if (this.isResale && this.resaleUserList.some(item => !item.selledAmount)) {
        this.$message.error($t('请输入最小为1的整数,总共可转售量为{slot1}', { slot1: this.showValue }))

        return
      }

      if (this.isResale && this.resaleUserList.some(item => !item.effectStartTime)) {
        this.$message.error($t('请选择生效日期'))

        return
      }
      // eslint-disable-next-line radix
      const price = this.resaleUserList.reduce((total, item) => total + parseInt(item.selledAmount), 0)
      if (this.isResale && price > getShowPrice(this.orderDetail, 'margin', 'G', 1)) {
        this.$message.error($t('超过总量'))

        return
      }

      if (this.isResale && !this.isProductOrder(this.orderDetail)) {
        const unAbleList = this.resaleUserList.filter(item => item.effectEndTime > this.orderDetail.endTime)
        if (unAbleList.length > 0) {
          this.$msgbox({
            title: $t('有效期提醒'),
            customClass: 'longBox',
            message: this.returnMsgboxMessage(unAbleList),
          })

          return
        }
      }
      if (
        this.isResale &&
        this.orderDetail.saleType !== 2 &&
        this.orderDetail.isTying &&
        this.resaleUserList.some(item => item.selledAmount < this.orderDetail.saleInfoTotalNum) &&
        this.tipList.length <= 0
      ) {
        this.$msgbox({
          title: $t('提醒'),
          customClass: 'longBox',
          message: $t(`您的转售存在转售数量小于搭售要求的规格{slot}的操作，不会搭售对应套餐`, {
            slot: getShowPrice(this.orderDetail, 'saleInfoTotalNum', 'G', 2) + getShowUnit(this.orderDetail),
          }),
          showCancelButton: true,
          confirmButtonText: $t('确定'),
          cancelButtonText: $t('取消'),
        }).then(() => {
          this.jumpNext()
        })
      } else if (this.isResale && this.tipList.length > 0 && !this.isProductOrder(this.orderDetail)) {
        this.$msgbox({
          title: $t('有效期提醒'),
          customClass: 'longBox',
          message: this.returnTipMessage(this.tipList),
          showCancelButton: true,
          confirmButtonText: $t('确定'),
          cancelButtonText: $t('取消'),
        }).then(() => {
          this.jumpNext()
        })
      } else {
        // 授权订单校验接口
        if (!this.isResale) {
          this.checkAuth()
        } else {
          this.jumpNext()
        }
      }
    },
    // 校验接口
    async checkAuth() {
      const orderAuthCustomerReqList = []
      this.userAvailableList.forEach(element => {
        if (!element.isAjax) {
          orderAuthCustomerReqList.push({
            authedGid: element.gid,
            authType: element.authType,
            amount: element.authType === 0 ? '' : element.amount,
            authedGidName: element.name,
          })
        }
      })
      const data = {
        authOrderId: this.orderDetail.id,
        authProductId: this.orderDetail.productId,
        orderAuthCustomerReqList,
        orderType: this.orderType,
      }
      const res = await this.$ajax(this.$url.checkAuthAmount(), data)
      this.orderDetail.afterResaleValue = res.data.data

      // 转售后余量
      if (res.data.code === 1) {
        this.$msgbox({
          title: $t('订单提醒'),
          customClass: 'longBox',
          message: $t('提示：被授权企业下有生效中的订单，本次授权操作后，依旧会优先扣减原订单余量'),
          showCancelButton: true,
          confirmButtonText: $t('确定'),
          cancelButtonText: $t('取消'),
        }).then(() => {
          this.jumpNext()
        })
      } else if (res.data.code === 2) {
        this.$msgbox({
          title: $t('订单提醒'),
          customClass: 'longBox',
          message: `<div>${$t(
            '注意！本次操作配额总量大于90%，授权企业该产品余量由{slot1}变更为{slot2}，可能导致授权企业与其他被授权企业的运行中的服务中断，请核实后确认',
            {
              slot1: `<span style="color:red">${this.showValue}</span>`,
              slot2: `<span style="color:red">${getShowPrice(this.orderDetail, 'afterResaleValue', 'G', 2)}${getShowUnit(
                this.orderDetail
              )}</span>`,
            }
          )}</div>
          `,
          showCancelButton: true,
          dangerouslyUseHTMLString: true,
          confirmButtonText: $t('确定'),
          cancelButtonText: $t('取消'),
        }).then(() => {
          this.jumpNext()
        })
      } else if (res.data.code === 3) {
        this.$msgbox({
          title: $t('订单提醒'),
          customClass: 'longBox',
          message: `<div style="margin:10px">${$t(
            '注意！本次操作配额总量大于90%，授权企业该产品余量由{slot1}变更为{slot2}，可能导致授权企业与其他被授权企业的运行中的服务中断，请核实后确认',
            {
              slot1: `<span style="color:red">${this.showValue}</span>`,
              slot2: `<span style="color:red">${getShowPrice(this.orderDetail, 'afterResaleValue', 'G', 2)}${getShowUnit(
                this.orderDetail
              )}</span>`,
            }
          )}</div><div style="margin:10px;font-size:12px">
          ${$t('提示：被授权企业下有生效中的订单，本次授权操作后，依旧会优先扣减原订单余量')}</div>
          `,
          showCancelButton: true,
          dangerouslyUseHTMLString: true,
          confirmButtonText: $t('确定'),
          cancelButtonText: $t('取消'),
        }).then(() => {
          this.jumpNext()
        })
      } else if (res.code === '20502100') {
        this.failResultList = res.data.failResultList
        this.failResultListDialog = true
      } else {
        this.jumpNext()
      }
    },
    jumpNext() {
      tsignData.track('PC_bill_Next', { buttonName: 'authorization' })
      const data = {
        orderId: this.orderDetail.id,
        orderType: this.orderType,
        orderShowId: this.orderDetail.showId,
        productName: this.orderDetail.commodityName,
        unit: getShowUnit(this.orderDetail, 'G'),
        isResale: this.isResale,
        isProductOrder: this.isProductOrder(this.orderDetail),
        showAddServerButton: this.showAddServerButton,
        margin: getShowPrice(this.orderDetail, 'margin', 'G', 1),
        productId: this.orderDetail.productId,
        isUnLimitNum: this.orderDetail.isUnLimitNum,
      }
      if (!this.isResale) {
        data.authList = this.userAvailableList.filter(item => item.name && item.gid)
        for (const item of data.authList) {
          item.amount = item.authType === 0 ? this.authLeaveNumber : item.amount
        }
      } else {
        data.authList = this.resaleUserList
      }
      sessionStorage.setItem('detailInfo', JSON.stringify(data))
      this.$router.push('sureSend')
    },
    // 删除已添加的授权项
    delUserAvailableItem(index, item) {
      this.userAvailableList.splice(index, 1)
      this.checkedUser.splice(
        this.checkedUser.findIndex(i => i == item.gid),
        1
      )
      // 同步勾选项状态
      this.checkAll = this.isCheckAll()
    },
    // 限制授权配额模式下编辑的最大份额
    limitMaxNumber(value, item) {
      if (value <= 0) {
        this.$set(item, 'amount', 0)
        this.$message.error($t('配额数量必须大于0'))

        return
      }
      if (this.authLeaveNumber < 0 || value > this.authMaxNumber) {
        this.$set(item, 'amount', 0)
        this.$message.error($t('配额总数不能超过当前可授权数量'))

        return
      }
      this.$set(item, 'amount', parseInt(value))
    },
  },
  created() {
    this.ouid = localStorage.getItem('ouid')
    this.orderType = this.$route.query.orderType ? this.$route.query.orderType * 1 : 0
  },
  mounted() {
    this.getOrderDetail()
  },
}
</script>
<style>
.longBox {
  width: 500px !important;
}
</style>
<style lang="less" scoped>
/deep/ input[type='number'] {
  -moz-appearance: textfield;
}
/deep/ input[type='number']::-webkit-inner-spin-button,
/deep/ input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.el-icon-remove {
  color: #0975e0ff;
}


.hasPic {
  position: relative;
  > img {
    position: absolute;
    z-index: 100;
    top: 30px;
    left: 30px;
  }
}
.userAvailable-footer {
  justify-content: flex-end;
}
.search-input {
  width: 80%;
}
.quotaOrder {
  color: #000;
}

/deep/ .es-input-number {
  width: 100px;
}
.wd-150 {
  width: 150px !important;
}
.wd-400 {
  width: 400px;
}
.wd-360 {
  width: 360px;
}
.wd-260 {
  width: 260px;
}
.wd-100 {
  width: 100px;
}
.wd-90 {
  width: 90px;
}
.ml-20 {
  margin-left: 20px;
}
.wd-70 {
  width: 70px;
}
.flex {
  display: flex;
}
.reSale-user-body {
  height: 45px;
  line-height: 45px;
  border-top: 1px solid #e4e4e4;
  box-shadow: 0px 1px 0px 0px #e4e4e4;
  display: flex;
  padding: 0 16px;
}
.time {
  display: flex;
  align-items: center;
}
.footer {
  margin: 24px 0;
}
.anth-container {
  display: flex;
  .left-select {
    width: 350px;
    padding: 10px 10px;
    .auth-title {
      text-align: center;
    }
    .select-main {
      margin: 10px 0;
      padding: 5px;
      border: 1px solid #eee;
      .inline-input {
        width: 100%;
      }
      .checkbox-section {
        padding: 10px 10px;
        min-height: 100px;
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;
        .checkbox-item {
          width: 100%;
        }
        .empty {
          text-align: center;
        }
      }
      .check-all {
        border-top: 1px solid #eee;
        padding: 0 10px;
      }
    }
  }
}

.auth-name {
  padding: 0 30px;
  color: #333;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.table {
  padding: 10px 20px;
  flex: 1;
  box-shadow: 0px 0px 6px 0px #dce0ef;
  &-content {
    max-height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  &-body-title,
  &-body-main {
    line-height: 50px;
    border-top: none;
    color: #999999;
    .operation {
      padding: 0 20px;
      i {
        cursor: pointer;
      }
    }
  }
  .add-item {
    cursor: pointer;
    border: 1px dashed rgba(204, 204, 204, 1);
    text-align: center;
    height: 32px;
    font-size: 20px;
  }
  .shareOrder {
    padding-left: 7%;
    width: 80%;
    color: #000;
    font-size: 14px;
  }
  &-header {
    padding: 0 20px 0 30px;
    height: 80px;
    color: #232323ff;
    background: #f7f8faff;
    font-weight: 400;
    font-size: 14px;
    display: flex;
    flex-direction: column;

    border: 1px solid #e4e4e4;
    span {
      margin-top: 15px;
    }
    span:last-child {
      color: #1a1a1aff;
    }
  }
  &-body {
    color: #666666;
    border: 1px solid #e4e4e4;
    border-top: none;
    &-title {
      padding-left: 30px;
      border-bottom: 1px solid #f3f3f3;
    }
    .es-row {
      padding-left: 30px;

      line-height: 50px;
      height: 50px;
    }
  }
}

.table-user-title {
  padding: 0 16px;
  height: 42px;
  line-height: 42px;
  background: #fafafa;
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0px 1px 0px 0px rgba(228, 228, 228, 1);
  display: flex;
}
.tip {
  padding: 30px 0;
  font-size: 14px;
  color: #333;
}

.userAvailable {
  background: #f7f8faff;
  padding-bottom: 24px;
  &-list {
    margin: 0 20px;
    div {
      height: 40px;
      line-height: 40px;
      display: flex;
      span:first-child {
        width: 130px;
        color: #1a1a1a;
        font-weight: 400;
      }
    }
    i {
      padding: 12px;
      color: #108de9;
      font-size: 15px;
      cursor: pointer;
    }
  }
}
.reSale-user-buttonGrup {
  height: 50px;
  display: flex;
  align-items: center;
  div.button {
    border: 1px solid #0975e0ff;
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #0975e0ff;
    cursor: pointer;
  }
}
.wd-200 {
  width: 200px;
}
</style>
